@if (!accountAgingStatus || accountAgingStatus === 'TERMINATED') {
    <div class="flex flex-col p-5 xl:p-16">
        <div
            class="flex flex-row border border-gray-border rounded-lg bg-white p-6 gap-6 xl:gap-12">
            <div class="shrink-0 w-1/4 xl:w-auto">
                <img
                    ngSrc="assets/images/ar-manager.png"
                    height="475"
                    width="414"
                    alt="AR Manager" />
            </div>
            <div class="flex flex-col gap-6 xl:py-12 grow max-w-[800px]">
                <h1 class="text-4xl text-main-red font-semibold m-0">
                    Insurance AR Manager
                </h1>
                <h3 class="text-2xl font-semibold m-0">
                    Master the Chaos with a centralized, digital billing hub to
                    manage your aging claims.
                </h3>
                <div>
                    <h3 class="text-2xl mb-2">
                        <i class="fa-solid fa-check text-green-600 mr-3"></i
                        >Improve your AR
                    </h3>
                    <h3 class="text-2xl mb-2">
                        <i class="fa-solid fa-check text-green-600 mr-3"></i
                        >Increase your visibility
                    </h3>
                    <h3 class="text-2xl mb-2">
                        <i class="fa-solid fa-check text-green-600 mr-3"></i
                        >Streamline your billing operations
                    </h3>
                </div>
                <div class="flex flex-row">
                    <rcp-com-button
                        [buttonStyle]="ButtonStyle.Primary"
                        label="Learn More"
                        (clickEvent)="openLearnMore()"></rcp-com-button>
                    <rcp-com-button
                        [buttonStyle]="ButtonStyle.Tertiary"
                        label="Schedule a Tour"
                        (clickEvent)="openScheduleTour()"></rcp-com-button>
                </div>
            </div>
        </div>
    </div>
}
@if (
    accountAgingStatus === 'NEW' || accountAgingStatus === 'PENDING_ONBOARDING'
) {
    <div class="flex flex-col p-5">
        <div class="border border-gray-border rounded-lg bg-white p-6">
            <div class="flex flex-row items-center">
                <i
                    class="fa-solid fa-circle-dollar fa-4x text-main-red pr-4"></i>
                <div class="flex flex-col">
                    <h3 class="text-2xl font-semibold m-0">
                        We're getting things ready.
                    </h3>
                    <h4 class="text-xl font-medium m-0">
                        A support specialist will be in touch with onboarding
                        instructions.
                    </h4>
                </div>
            </div>
        </div>
    </div>
}
@if (accountAgingStatus === 'ONBOARDING') {
    <div class="flex flex-col p-5">
        <div class="border border-gray-border rounded-lg bg-white p-6">
            <div class="flex flex-row items-center">
                <i
                    class="fa-solid fa-circle-dollar fa-4x text-main-red pr-4"></i>
                <div class="flex flex-col">
                    <h3 class="text-2xl font-semibold m-0">
                        Onboarding in progress.
                    </h3>
                    <h4 class="text-xl font-medium m-0">
                        Access will be granted when all onboarding steps have
                        been completed.
                    </h4>
                </div>
            </div>
        </div>
    </div>
}
